import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Prototype of the proposed issue status icon: a 1.5px open ring with a 1.5px, round-capped
// half arc running clockwise from 12 o'clock, 1.5px inside the ring to match the ring
// spacing of goal-16. Pending the final Octicon.
export const IssueInProgressIcon: Icon = props => {
  return (
    <CustomIcon {...props}>
      <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0M1.5 8a6.5 6.5 0 1 0 13 0 6.5 6.5 0 0 0-13 0" />
      <path d="M8 3a5 5 0 0 1 0 10 .75.75 0 0 1 0-1.5 3.5 3.5 0 0 0 0-7A.75.75 0 0 1 8 3" />
    </CustomIcon>
  )
}
